import {
  ImportantMessage,
  Mtds,
  NotePencilIcon,
  PlayIcon,
  StopIcon,
  toLocaleDateString,
  TrashIcon,
  useGetOwnerNameQuery,
  useAuth,
  UserIcon
} from 'prove-common'

type ImportantMessageCardProps = {
  message: ImportantMessage
  onClickEdit: (message: ImportantMessage) => void
  onClickDelete: (message: ImportantMessage) => void
}

export const ImportantMessageCard = ({
  message,
  onClickEdit,
  onClickDelete
}: ImportantMessageCardProps) => {
  const { isAdmin } = useAuth()
  const { data: createdBy } = useGetOwnerNameQuery(message.createdBy)

  return (
    <Mtds.Card
      key={message.id}
      as={Mtds.Flex}
      data-justify='space-between'
      data-nowrap
    >
      <Mtds.Prose>
        <Mtds.Heading as='h5' data-size='xs'>
          {message.title}
        </Mtds.Heading>
        <p className='break-all'>{message.text}</p>
        <Mtds.Flex data-gap={8}>
          <Mtds.Info>
            <PlayIcon />
            {toLocaleDateString(message.startDate)}
          </Mtds.Info>
          <Mtds.Info>
            <StopIcon />
            {toLocaleDateString(message.endDate)}
          </Mtds.Info>
          <Mtds.Info>
            <UserIcon />
            {createdBy?.name}
          </Mtds.Info>
        </Mtds.Flex>
      </Mtds.Prose>
      <Mtds.Button
        aria-label='Handlingsmeny'
        popoverTarget={`important-message-card-menu-${message.id}`}
      />
      <Mtds.Popover as='menu' id={`important-message-card-menu-${message.id}`}>
        <li>
          <Mtds.Button onClick={() => onClickEdit(message)} disabled={!isAdmin}>
            <NotePencilIcon />
            Rediger
          </Mtds.Button>
        </li>
        <li>
          <Mtds.Button
            data-color='danger'
            onClick={() => onClickDelete(message)}
            disabled={!isAdmin}
          >
            <TrashIcon />
            Slett
          </Mtds.Button>
        </li>
      </Mtds.Popover>
    </Mtds.Card>
  )
}
